import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../hooks/useSetState';
import { DeviceUUID } from 'device-uuid';
import { registerNewUser } from '../../redux/login/actions';
import ErrorModal from '../../component/ErrorModal';
import { ArrowLeft } from 'iconsax-react';

const UserRegister = ({ ...props }) => {
  let history = useHistory();
  const [message, setMessage] = useState('');

  const { registerNewUserMessage } = useSelector((state) => ({
    registerNewUserMessage: state.loginOrRegisterReducer.registerNewUserMessage,
  }));

  const [controls, setControls] = useSetState({
    firstName: '',
    lastName: '',
    mobileNumber: props.location.mobileNumber,
    deviceId: '',
    platform: 'PWA',
    fcmToken: '',
    policy: false,
    usedInviteFriendCode: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({
      [controleName]: value,
    });
  };

  const dispatch = useDispatch();

  const onClickBackButton = () => {
    history.push('/login');
  };

  const validationForm = () => {
    return new Promise((resolve, reject) => {
      const standardFirstName = formatter.toStandard(controls.firstName);
      const standardLastName = formatter.toStandard(controls.lastName);

      let isFirstNameValid;
      let isLastNameValid;
      let errors = {};

      if (!standardFirstName) {
        errors.nameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.name'),
          },
        );
        errors.nameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'name';
        isNameValid = false;
      } else {
        errors.nameInputInvalidMessage = '';
        errors.nameInputValidateStatus = '';
        isNameValid = true;
      }

      if (!standardLastName) {
        errors.ownerFullNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.owner.full.name'),
          },
        );
        errors.ownerFullNameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'ownerFullName';
        isOwnerFullNameValid = false;
      } else {
        errors.ownerFullNameInputInvalidMessage = '';
        errors.ownerFullNameInputValidateStatus = '';
        isOwnerFullNameValid = true;
      }

      const isFormValid = isFirstNameValid && isLastNameValid;

      if (!isFormValid) {
      } else {
        resolve(true);
      }
    });
  };

  const submitForm = (event) => {
    event.preventDefault();

    let uuid = new DeviceUUID().get();
    if (!controls.policy) {
      setMessage(locales('please.read.and.confirm.the.policy'));
    } else {
      setMessage('');
      let data = {
        mobileNumber: controls.mobileNumber,
        firstName: controls.firstName,
        lastName: controls.lastName,
        deviceId: uuid,
        platform: controls.platform,
        fcmToken: controls.fcmToken,
        usedInviteFriendCode: controls.usedInviteFriendCode,
      };

      dispatch(registerNewUser(data)).then((res) => {
        history.push({
          pathname: '/login/verification-code',
          mobileNumber: controls.mobileNumber,
          action: 'VERIFY_PHONE_NUMBER',
        });
      });
    }
  };

  useEffect(() => {
    const uuid = new DeviceUUID().get();
    onChangeValue('deviceId', uuid.replaceAll('-', ''));

    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < 180; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    onChangeValue('fcmToken', result);
  }, []);

  return (
    <section className='overflow-x-hidden scrollbar-hide md:w-1/2 lg:w-1/3 m-auto relative h-screen'>
      <section className='m-5'>
        <div className='flex flex-row-reverse justify-between mb-8'>
          <div
            className='w-fit p-3 border border-lightBorder rounded-xl'
            onClick={() => onClickBackButton()}
          >
            <ArrowLeft size='16' />
          </div>
          <div className='flex items-center'>
            <h1 className='text-xl'>{locales('user.register')}</h1>
          </div>
        </div>

        <div className='leading-10'>
          <form onSubmit={(event) => submitForm(event)} id='registration'>
            <div className='w-full flex flex-col'>
              <p className='text-md font-medium'>
                {locales('please.write.your.name')}
              </p>
              <input
                required='true'
                type='text'
                lang='fa'
                value={controls.firstName}
                placeholder='نام'
                className='w-full border border-lightBorder rounded-xl text-sm p-3 my-1.5
                focus:border-secondary-100 focus:outline-none'
                onChange={(event) =>
                  onChangeValue('firstName', event.target.value)
                }
                onInvalid={(F) =>
                  F.target.setCustomValidity(locales('please.enter.your.first.name'))
                }
                onInput={(F) => F.target.setCustomValidity('')}
              />
            </div>

            <div className='w-full'>
              <input
                required='true'
                type='text'
                value={controls.lastName}
                placeholder='نام خانوادگی'
                className='w-full border border-lightBorder rounded-xl text-sm p-3 my-1.5
                focus:border-secondary-100 focus:outline-none'
                onChange={(event) =>
                  onChangeValue('lastName', event.target.value)
                }
                onInvalid={(F) =>
                  F.target.setCustomValidity(locales('please.enter.your.last.name'))
                }
                onInput={(F) => F.target.setCustomValidity('')}
              />
            </div>

            <div className='my-4 w-full'>
              <p className='text-md font-medium'>
                {locales('please.enter.your.invitation.code.if.you.have')}
              </p>
              <div className='flex justify-between items-center'>
                <input
                  type='text'
                  value={controls.usedInviteFriendCode}
                  placeholder='کد معرف'
                  className='w-full border border-lightBorder rounded-xl text-sm p-3 my-1.5
                  focus:border-secondary-100 focus:outline-none'
                  onChange={(event) =>
                    onChangeValue('usedInviteFriendCode', event.target.value)
                  }
                />
              </div>
            </div>

            <div className='my-4 text-sm text-right w-full'>
              <input
                required='true'
                type='checkbox'
                className='mx-2'
                value={controls.policy}
                onChange={(event) =>
                  onChangeValue('policy', event.target.checked)
                }
                onInvalid={(F) =>
                  F.target.setCustomValidity(locales('please.read.and.confirm.the.policy'))
                }
                onInput={(F) => F.target.setCustomValidity('')}
              />
              <a
                href='https://rsee.ir/#policies'
                target='_blank'
                className='text-primary-100'
              >
                {locales('accept.policy')}
              </a>
            </div>
          </form>
          <ErrorModal errorMessage={message} />
        </div>

        <div className='w-full flex justify-center absolute bottom-4 right-0'>
          <button
            type='submit'
            form='registration'
            className='large-button bg-primary-100 text-white text-sm'
          >
            {locales('continue')}
          </button>
          <ErrorModal errorMessage={registerNewUserMessage} />
        </div>
      </section>
    </section>
  );
};

export default UserRegister;
